export default {
    seguromovil: "",
    seguromultidispositivo: "",
    seguroportatil: ""
}